import { formatBytes } from '../../../shared/attachments.js'
import { Icon } from '../icons/Icon.jsx'
import styles from './Composer.module.css'

const KIND_LABEL = { image: 'Image', pdf: 'PDF' }

function kindLabel(file) {
  return KIND_LABEL[file.kind] ?? (file.name.split('.').pop() || 'File').toUpperCase()
}

/** One file in the composer: preview or icon, name, upload state, remove. */
export function AttachmentChip({ file, onRemove, onRetry }) {
  const uploading = file.status === 'uploading'
  const failed = file.status === 'failed'
  const meta = uploading ? 'Uploading…' : failed ? file.error : `${kindLabel(file)} · ${formatBytes(file.size)}`
  return (
    <li className={`${styles.chip} ${failed ? styles.chipFailed : ''}`}>
      {file.kind === 'image' && file.preview ? (
        <img className={styles.chipThumb} src={file.preview} alt="" />
      ) : (
        <span className={styles.chipIcon} aria-hidden="true">
          <Icon name="file" size={16} strokeWidth={1.6} />
        </span>
      )}
      <span className={styles.chipText}>
        <span className={styles.chipName} title={file.name}>
          {file.name}
        </span>
        <span className={styles.chipMeta} title={failed ? file.error : undefined} aria-live="polite">
          {meta}
        </span>
      </span>
      {uploading ? <span className={styles.chipSpinner} aria-hidden="true" /> : null}
      {failed ? (
        <button type="button" className={styles.chipAction} onClick={onRetry}>
          Retry
        </button>
      ) : null}
      <button type="button" className={styles.chipRemove} aria-label={`Remove ${file.name}`} onClick={onRemove}>
        <Icon name="close" size={13} strokeWidth={1.8} />
      </button>
    </li>
  )
}
